/* eslint-disable no-console */
import { useEffect, useRef, useState } from 'react';

import axios from 'axios';
import { useTranslation } from 'react-i18next';

import { selectLoading, selectUserData } from 'redux/editProfile/userProfile.slices';
import { profilePicture, setAvatarUrl } from 'redux/authentication/auth.slice';
import { useAppSelector, useAppDispatch } from 'redux/hooks';
import { ReactComponent as EditPen } from 'assets/icons/menu/edit.svg';
// import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import { SERVICE_ENDPOINT } from 'utils/constants';

import Password from './components/password/Password';
import PersonalInformation from './components/personalInformation/PersonalInformation';

import './EditProfile.scoped.scss';
import Loader from '../../clean/components/Loader/Loader';

const EditProfile: React.FC = () => {
  const dispatch = useAppDispatch();
  const [activeId, setActiveId] = useState(1);
  const userData = useAppSelector(selectUserData);
  const loading = useAppSelector(selectLoading);
  const profilePicUrl = useAppSelector(profilePicture);
  const [isUploading, setIsUploading] = useState(false);
  const inputFile = useRef(null);
  const { t } = useTranslation();
  const info = [
    { title: 'Personal_Information', id: 1 },
    { title: 'passwords', id: 2 },
    // { title: 'create_user', id: 3 },
  ];
  const onAvatarEdit = () => {
    inputFile.current.click();
  };

  useEffect(() => {
    console.log({
      profilePicUrl,
    });
  }, [profilePicUrl]);

  const showPicture = () => {
    return userData && !isUploading && loading;
  };

  const handleAvatarChange = async event => {
    try {
      setIsUploading(true);
      const file = event.target.files[0];

      const bodyFormData = new FormData();
      bodyFormData.append(file.name, file);
      bodyFormData.append('foreign_id', userData.id);
      bodyFormData.append('table', 'ProfilePictures');

      // POST FormData to file upload API
      const response = await axios({
        method: 'post',
        url: `${SERVICE_ENDPOINT}api/file/upload`,
        data: bodyFormData,
        headers: { 'Content-Type': 'multipart/form-data', 'Access-Control-Allow-Origin': '*' },
      });

      const newUrl = response.data[1];
      dispatch(setAvatarUrl(newUrl));
    } catch (error) {
      throw new Error(error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="editprofile-wrap">
      <div className="editprofile-header">
        {info.map(item => (
          <div
            className={`section${activeId === item.id ? '-active' : ''}`}
            onClick={() => setActiveId(item.id)}
            key={item.id}
          >
            <h4>{t(`common:${item.title}`)}</h4>
          </div>
        ))}
      </div>
      <div className="editprofile-container">
        <div className="editprofile-container-left">
          <div className="editprofile-container-left-top">
            <div className="avatar-wrap">
              <div className="icon-container">
                <EditPen className="avatar-edit-button" onClick={onAvatarEdit} />
              </div>
              {showPicture() && (
                <div className="avatar" style={{ backgroundImage: `url(${profilePicUrl})` }}>
                  <input
                    type="file"
                    ref={inputFile}
                    style={{ display: 'none' }}
                    onChange={handleAvatarChange}
                  />
                </div>
              )}
              {!showPicture() && (
                <div className="loader-container">
                  <Loader size={80} />
                </div>
              )}
            </div>
            <div className="info">
              <h3>
                {userData?.first_name} {userData?.last_name}
              </h3>

              <h5>
                {userData?.role === 'student'
                  ? 'Studierende'
                  : userData?.role === 'teacher'
                  ? 'Dozent'
                  : 'Elternteil'}
              </h5>
            </div>
          </div>
        </div>
        <div className="editprofile-container-right">
          <div className="editprofile-container-right-bottom">
            {activeId === 1 && <PersonalInformation />}
            {activeId === 2 && <Password />}
            {/* {activeId === 3 && <CreateUserInformation />} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
